import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { track } from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { submitPql } from '../pql/submitPql';
import { upgradeDataPropsInterface } from '../common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import { ReducedOptionsModal } from 'ui-addon-upgrades/_core/communicationMethods/ReducedOptionsModal';
import { loadAndOpenSalesChat } from '../utils/loadAndOpenSalesChat';
import { getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { trackPricingPagePql } from '../utils/metricUtils';
export const RetailModal = ({
  handleIframeSizeChange,
  onClose,
  upgradeData,
  hideBackground,
  ModalComponent,
  modalRoot,
  isUpgradePoint
}) => {
  const onModalView = () => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'viewed retail modal'
    }, getUpgradeDataTrackingProperties(upgradeData, isUpgradePoint)));
    submitPql(Object.assign({}, upgradeData, {
      isRetail: true,
      isAssignable: false
    }));
    trackPricingPagePql(upgradeData.app);
  };

  const handleClickChatTrack = () => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'clicked retail chat button'
    }, getUpgradeDataTrackingProperties(upgradeData, isUpgradePoint)));
    loadAndOpenSalesChat({
      upgradeData,
      isRetail: true
    });
    onClose();
  };

  const handleClickCallTrack = () => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'clicked retail phone button'
    }, getUpgradeDataTrackingProperties(upgradeData, isUpgradePoint)));
  };

  return /*#__PURE__*/_jsx(ReducedOptionsModal, {
    onModalView: onModalView,
    onClickChat: handleClickChatTrack,
    onClickCall: handleClickCallTrack,
    onClose: () => onClose(),
    isRetail: true,
    upgradeData: upgradeData,
    modalRoot: modalRoot,
    handleIframeSizeChange: handleIframeSizeChange,
    hideBackground: hideBackground,
    ModalComponent: ModalComponent
  });
};
RetailModal.propTypes = Object.assign({
  handleIframeSizeChange: PropTypes.func,
  hideBackground: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  ModalComponent: PropTypes.elementType,
  modalRoot: PropTypes.object
}, upgradeDataPropsInterface);